var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var drawHoleDataTo2D = require("./../../renderData/drawHoleDataTo2D.js");
var cio_datamodel = require("cio-datamodel");

//var ToSVGFunction = cio_shared.holeDataToSVG;

var HoleInteractionView = function (gui, interactionModel, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.interactionModel = interactionModel;
    this.data = interactionModel.data;
    this.editorModel = interactionModel.editorModel;

    this.cameraModel = this.gui.editorModel.cameraModel();

    var localLayers = this.getLayers(layers);

    this.initGroups(parentGroup, [localLayers.draw, localLayers.control]);

    this.holeGroup = this.getGroupInfo(localLayers.draw).svgGroup;
    this.holeControlGroup = this.getGroupInfo(localLayers.control).svgGroup;

    $(this.holeControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    this.draw();

    this.interactionModel.selected.onChange(self, function(value){
        self.setSelected(value);
    },10);

    var scheduleRedraw = function () {
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    };

    this.cameraModel.viewS.onChange(self, function() {
        self.gui.heavyHandler.scheduleHeavy('resize_control', self.resizeControl, self, [], self);
    },10);

    this.data.onBubble(this, scheduleRedraw);
};
lib_core.mixin(HoleInteractionView, editor_2d.DrawingElement);

module.exports = HoleInteractionView;

HoleInteractionView.prototype.draw = function () {
    var self = this;
    $(this.holeGroup).empty();
    $(this.holeControlGroup).empty();

    if (!this.data.isAlive()) return;

    drawHoleDataTo2D(this.gui.svg, this.holeGroup, this.data);
    drawHoleDataTo2D(this.gui.svg, this.holeControlGroup, this.data);

    this.control = $(":nth-last-child(1)",this.holeControlGroup);
    this.resizeControl();
};

HoleInteractionView.prototype.getLayers = function(layers){
    if(layers.draw && layers.control) return layers;

    return {
        draw: layers.drill,
        control: layers.drillControl
    }
}


HoleInteractionView.prototype.resizeControl = function () {
    if(this.control) this.control.attr("stroke-width", 4 / this.cameraModel.viewS()); // make control a little larger
};

HoleInteractionView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element( this.interactionModel )
        .data( 'mouseCoord', this.gui.relativeMouseCoord(event) );

    return this.gui.stateMachine.handle(cEvent);
};
